import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../App';
import ProjectCard from '../../ProjectCard/ProjectCard';
import './MyWork.css';
import sample from '../../../images/sample.png';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'

const MyWork = () => {
    const history = useHistory();
    const [
        cardDisplay, setCardDisplay,
        authentication, setAuthentication,
        snackBarUI, setSnackBarUI,
        backdropUI, setBackdropUI
    ] = useContext(UserContext);

    const prevSlide = () => {
        let value = cardDisplay;
        if (value === 0) {
            value = data.length - 1;
            setCardDisplay(value);
        }
        else {
            value = cardDisplay - 1;
            setCardDisplay(value);
        }
    }

    const nextSlide = () => {
        let value = cardDisplay;
        if (value === data.length - 1) {
            value = 0;
            setCardDisplay(value);
        }
        else {
            value = cardDisplay + 1;
            setCardDisplay(value);
        }
    }

    const [data, setData] = useState([]);
    useEffect(() => {
        fetch('https://stormy-mesa-29040.herokuapp.com/getAllProjects')
            .then(res => res.json())
            .then(data => setData(data))
            .catch(err => {
                alert(err);
            })
    }, [])

    return (
        <div id="my-work">
            <div className="App container-work">
                <div className="center container">
                    <h1 className="h1-sec">My Work</h1>
                    <hr className="hr-sec" />
                    <br /><br /><br />
                    <div>
                        JavaScript: <span className="padding purple"></span>
                        CSS: <span className="padding green"></span>
                        HTML: <span className="padding orange"></span>
                    </div>
                    <br /><br /><br />
                    <section>
                        {
                            data.length > 0 && <ProjectCard data={data[cardDisplay]} />
                        }
                    </section>
                    <section>
                        <div className="center-row mb-4">
                            {
                                data.map(
                                    (info, index) =>
                                        index === cardDisplay ? <span className="dot"></span>
                                            : <span className="dot-hash"></span>
                                )
                            }
                        </div>
                        <span onClick={prevSlide} className="symbol">&lt;</span>
                        <span onClick={nextSlide} className="symbol">&gt;</span>
                    </section>
                    <br />
                    <Button onClick={() => history.push('/projects')} className="btn-border" variant="outline-dark">
                        SEE ALL PROJECTS
                        <FontAwesomeIcon className="icon-color custom-icon ml-2" icon={faLongArrowAltRight} />
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default MyWork;